import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import imgLogo from "../../../../../image/logo.png";
import api from "../../../../../utils/apidsf";
import swal from "sweetalert";
import RichTextEditor from "react-rte";
import ReactTextArea from "../../../Components/ReactTextediter/ReactTextArea";
import csvParser from "papaparse";

import "./CreatePyq.css";

// components
import FormField from "../../../Components/FormField/FormField";
import apidsf from "../../../../../utils/apidsf";

export default function CreatePyq() {
  const params = useParams();
  const navigate = useNavigate();
  //const [id, setId] = useState("");

  const [isExcel, setisExcel] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const [show, setShow] = useState({
    showState: false,
    showYear: false,
    showUni: false,
    showExam: false,
    loading: false,
    examSelect: false,
    ugcSubject: false,
    showllbExam: false,
  });
  const [formData, setFormData] = useState({
    subject: "",
    state: "",
    university: "",
    ugc_subject: "",
    exam: "",
    year: "",
    reactTeaxttitle: RichTextEditor.createEmptyValue(),
    reactTeaxtdescription: RichTextEditor.createEmptyValue(),
    title: "",
    solution_description: "",
    optionOne: "",
    optionTwo: "",
    optionThree: "",
    optionFour: "",

    rightAnswer: "",
    subjectSet: "",
  });
  const {
    subject,
    state,
    university,
    exam,
    year,
    title,
    solution_description,
    reactTeaxtdescription,
    reactTeaxttitle,
    ugc_subject,
    optionOne,
    optionTwo,
    optionThree,

    optionFour,
    rightAnswer,
    subjectSet,
  } = formData;
  console.log(reactTeaxtdescription);
  const handleInputChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };
  const [subjectlist, setsubjectlist] = useState([]);
  const getSubject = () => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    apidsf.get("/admin/getsubject", config).then((e) => {
      console.log(e);
      setsubjectlist(e?.data?.Subject);
    });
  };

  const ChechKeys = (object) => {
    console.log(object);
    return (
      object.hasOwnProperty("title") &&
      object.hasOwnProperty("optionOne") &&
      object.hasOwnProperty("optionTwo") &&
      object.hasOwnProperty("optionThree") &&
      object.hasOwnProperty("optionFour") &&
      object.hasOwnProperty("rightAnswer") &&
      object.hasOwnProperty("solution_description")
    );
  };

  const convetData = async (result, restData, callbackFunc) => {
    let paresedData = [];
    let excelData = result.data;
    const isValid = ChechKeys(excelData[0]);
    if (isValid) {
      for (let data of excelData) {
        console.log({ data });
        paresedData.push({ ...restData, ...data });
      }
      console.log({ paresedData });
      callbackFunc(paresedData);
    } else {
      swal({
        title: "Error",
        text: "Invalid CSV Format",
        icon: "error",
      });
      setShow({
        ...show,
        loading: false,
      });
    }
  };

  const clearFileInput = () => {
    const fileInput = document.querySelector(".Excel__fileInput");
    console.log(fileInput.childNodes);
    fileInput.childNodes[1].value = "";
    setSelectedFile(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShow({
      ...show,
      loading: true,
    });
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const createOrUpdateLandmark = async () => {
      try {
        let res = null;

        if (isExcel == "true") {
          console.log("Entering Excel data");
          const reqBody = {
            subject: formData.subject,
            state: formData.state,
            university: formData.university,
            exam: formData.exam,
            year: formData.year,
            ugc_subject: formData.ugc_subject,
            subjectSet: formData.subjectSet,
          };

          let finalData = [];

          csvParser.parse(selectedFile, {
            skipEmptyLines: true,
            header: true,
            complete: (result) => {
              finalData = convetData(result, reqBody, async (data) => {
                try {
                  res = await api.post(
                    "/admin/pyq/addPYQExcel",
                    { data: data },
                    config
                  );
                  console.log({ res });
                  clearFileInput();

                  if (res.status == 200) {
                    swal({
                      title: "Pyq Added",
                      text: "Pyq Added Successfully",
                      icon: "success",
                    });
                    setShow({
                      ...show,
                      loading: false,
                    });
                  }
                } catch (err) {
                  console.log(err);
                  swal({
                    title: "!Error",
                    text: err.response.data.error.message,
                    icon: "error",
                  });
                  console.log({ err });
                }
              });
            },
            error: (err) => {
              console.log(err);
              swal({
                title: "Error",
                text: "Invalid CSV Format",
                icon: "error",
              });
              setShow({
                ...show,
                loading: false,
              });
            },
          });

          console.log({ finalData });

          return;
        }

        if (id) {
          res = await api.put(`/admin/pyq/${id}`, formData, config);
        } else {
          res = await api.post("/admin/pyq/", formData, config);
        }
        const data = res.data.data;

        if (data && id) {
          swal({
            title: "Pyq Updated",
            text: "Pyq Updated Successfully",
            icon: "success",
          });
          navigate("/admin/pyq-table");
        } else {
          setFormData({
            ...formData,
            subject: formData.subject,
            state: formData.state,
            university: formData.university,
            ugc_subject: formData.ugc_subject,
            exam: formData.exam,
            year: formData.year,
            reactTeaxttitle: RichTextEditor.createEmptyValue(),
            reactTeaxtdescription: RichTextEditor.createEmptyValue(),

            title: "",
            solution_description: "",
            optionOne: "",
            optionTwo: "",
            optionThree: "",
            optionFour: "",
            subjectSet: "",
            rightAnswer: "",
          });
          swal({
            title: "Pyq Added",
            text: "Pyq Added Successfully",
            icon: "success",
          });
          // show error
        }
        setShow({
          ...show,
          loading: false,
        });
      } catch (err) {
        // console.error(err.response.data.error);
        console.log(err);
        setShow({
          ...show,
          loading: false,
        });
        swal({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
        });
        setShow({
          ...show,
          loading: false,
        });
      }
    };
    createOrUpdateLandmark();
  };

  useEffect(() => {
    getSubject();
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const fetchLandmark = async () => {
      const res = await api.get(`/admin/pyq/?_id=${id}`, config);
      const data = res.data.data[0];
      const {
        subject,
        state,
        university,
        title,
        reactTeaxttitle,
        reactTeaxtdescription,
        solution_description,
        exam,
        year,
        ugc_subject,
        optionOne,
        optionTwo,
        optionThree,
        optionFour,
        subjectSet,
        rightAnswer,
      } = data;

      checkSelectValue(subject);
      //checkUgcSubject(exam)

      setFormData({
        subject: subject,
        state: state,
        university: university,
        reactTeaxttitle: RichTextEditor.createValueFromString(title, "html"),
        reactTeaxtdescription: RichTextEditor.createValueFromString(
          solution_description,
          "html"
        ),

        exam: exam,
        year: year,
        ugc_subject: ugc_subject,
        title: title,
        solution_description: solution_description,
        optionOne: optionOne,
        optionTwo: optionTwo,
        optionThree: optionThree,
        optionFour: optionFour,
        subjectSet: subjectSet,
        rightAnswer: rightAnswer,
      });
    };

    if (id) {
      setisExcel("false");
      fetchLandmark();
    } else {
      setFormData({
        subject: "",
        state: "",
        university: "",
        exam: "",
        year: "",
        ugc_subject: "",
        reactTeaxttitle: RichTextEditor.createEmptyValue(),
        reactTeaxtdescription: RichTextEditor.createEmptyValue(),

        title: "",
        solution_description: "",
        optionOne: "",
        optionTwo: "",
        optionThree: "",
        optionFour: "",
        subjectSet: "",
        rightAnswer: "",
      });
    }
  }, [params]);

  const onChangeFunction = (value, Fieldname, valuename) => {
    let data = value.toString("html");
    setFormData({
      ...formData,
      [Fieldname]: data,
      [valuename]: value,
    });
  };
  const checkUgcSubject = (data) => {
    switch (data) {
      case "Paper Two":
        setShow({
          ...show,
          ugcSubject: true,
        });
        break;
      default:
        setShow({
          ...show,
          ugcSubject: false,
        });
    }
  };
  const checkSelectValue = (data) => {
    switch (data) {
      case "Judiciary":
        setShow({
          ...show,
          showState: true,
          showllbExam: false,
          showYear: true,
          showUni: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "ADA/APP/APO/JLO":
        setShow({
          ...show,
          showState: true,
          showYear: true,
          showllbExam: false,
          showUni: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "UGC NET":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showUni: false,
          showllbExam: false,
          showExam: false,
          examSelect: true,
          ugcSubject: false,
        });
        break;
      case "LLB Entrance":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showUni: false,
          showllbExam: true,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "LLM Entrance":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showUni: false,
          showExam: false,
          showllbExam: true,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "Phd in Law":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showllbExam: false,
          showUni: true,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "AIBE":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showUni: false,
          showllbExam: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "Law Officer":
        setShow({
          ...show,
          showState: false,
          showYear: false,
          showllbExam: false,
          showUni: false,
          showExam: true,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      default:
        setShow({
          ...show,
          showState: false,
          showYear: false,
          showllbExam: false,
          showUni: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
    }
  };
  console.log(formData);
  useEffect(() => {
    if (formData.exam == "Paper Two") {
      setShow({
        ...show,
        showState: show.showState,
        showYear: show.showYear,
        showUni: show.showUni,
        showExam: show.showExam,
        examSelect: show.examSelect,
        showUni: show.showUni,
        ugcSubject: true,
      });
    }

    if (formData.exam == "University") {
      setShow({
        ...show,
        showState: show.showState,
        showYear: show.showYear,
        showUni: true,
        showllbExam: show.showllbExam,
        showExam: show.showExam,
        examSelect: show.examSelect,
        ugcSubject: show.ugcSubject,
      });
    }
  }, [formData]);

  return (
    <div style={{ flex: 4 }}>
      <form action="" className="admin__userUpdateForm" onSubmit={handleSubmit}>
        <div className="userUpdateLeft">
          <div className="userUpdateItem">
            <label className="user__label">Select Subject Set</label>
            <select
              value={subjectSet}
              onChange={(e) => {
                return setFormData({
                  ...formData,
                  subjectSet: e.target.value,
                });
                // console.log(e.target.value);
              }}
            >
              <option value={undefined}>Select Subject Set</option>
              {subjectlist.map((e) => {
                return (
                  <option value={e.subject_name}>{e.subject_name}</option>
                  // <option value="Law">Law</option>
                );
              })}
            </select>
          </div>
          <div className="userUpdateItem">
            <label className="user__label">Subject</label>
            <select
              value={subject}
              onChange={(e) => {
                checkSelectValue(e.target.value);
                setFormData({
                  ...formData,
                  subject: e.target.value,
                });
              }}
            >
              <option value=" ">Select Subject</option>
              <option value="Judiciary">Judiciary</option>
              <option value="ADA/APP/APO/JLO">ADA/APP/APO/JLO</option>
              <option value="UGC NET">UGC NET</option>
              <option value="LLB Entrance">LLB Entrance</option>
              <option value="LLM Entrance">LLM Entrance</option>
              <option value="Phd in Law">Phd in Law</option>
              <option value="AIBE">AIBE</option>
              <option value="Law Officer">Law Officer</option>
            </select>
          </div>

          {show.examSelect ? (
            <div className="userUpdateItem">
              <label className="user__label">Exam</label>
              <select
                value={exam}
                onChange={(e) => {
                  checkUgcSubject(e.target.value);
                  setFormData({
                    ...formData,
                    exam: e.target.value,
                  });
                }}
              >
                <option value=" ">Select Exam</option>
                <option value="Paper One">Paper One</option>
                <option value="Paper Two">Paper Two</option>
              </select>
            </div>
          ) : (
            ""
          )}

          {show.ugcSubject ? (
            <div className="userUpdateItem">
              <label className="user__label">UGC Subject</label>
              <select
                value={ugc_subject}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    ugc_subject: e.target.value,
                  });
                }}
              >
                <option value=" ">Select Subject</option>
                <option value="Law">Law</option>
              </select>
            </div>
          ) : (
            ""
          )}

          {show.showllbExam ? (
            <div className="userUpdateItem">
              <label className="user__label">Exam</label>
              <select
                value={exam}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    exam: e.target.value,
                  });

                  if (e.target.value == "University") {
                    setShow({
                      ...show,
                      showUni: true,
                    });
                  }
                }}
              >
                <option value="">Select Exam</option>
                <option value="CLAT">CLAT</option>
                <option value="LSAT">LSAT</option>
                <option value="University">University</option>
              </select>
            </div>
          ) : (
            ""
          )}

          {show.showState ? (
            <FormField
              type="text"
              label="State"
              placeholder="State"
              value={state}
              name="state"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}
          {show.showUni ? (
            <FormField
              type="text"
              label="University"
              placeholder="University"
              value={university}
              name="university"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}
          {show.showExam ? (
            <FormField
              type="text"
              label="Exam"
              placeholder="Exam"
              value={exam}
              name="exam"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}

          {show.showYear ? (
            <FormField
              type="text"
              label="Year"
              placeholder="Year"
              value={year}
              name="year"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}

          <div className="ExcelChoice">
            <div>
              <input
                type="radio"
                name="selectType"
                value="true"
                onClick={(e) => {
                  console.log(e.target.value);
                  setisExcel(e.target.value);
                }}
              />
              <span>CSV</span>
            </div>

            <div>
              <input
                type="radio"
                name="selectType"
                value="false"
                onClick={(e) => {
                  console.log(e.target.value);
                  setisExcel(e.target.value);
                }}
              />
              <span> Manual</span>
            </div>
          </div>

          {isExcel == "true" && (
            <>
              <div className="Excel__fileInput">
                <label>Please Select a CSV file</label>
                <input
                  type="file"
                  name="excel"
                  accept="text/csv"
                  onChange={(e) => {
                    setSelectedFile(e.target.files[0]);
                    console.log(e.target.files[0]);
                  }}
                />
              </div>

              <div className="Excel__warning">
                Questions of above Fields will be overWritten this CSV
              </div>
            </>
          )}

          {isExcel == "false" && (
            <>
              <ReactTextArea
                lable="Title"
                Fieldname="title"
                mainvalue={reactTeaxttitle}
                valuename="reactTeaxttitle"
                onChangeFunction={onChangeFunction}
              />
              <FormField
                type="text"
                label="Option One"
                placeholder="Option One"
                value={optionOne}
                name="optionOne"
                handleChange={handleInputChange}
              />
              <FormField
                type="text"
                label="Option Two"
                placeholder="Option Two"
                value={optionTwo}
                name="optionTwo"
                handleChange={handleInputChange}
              />
              <FormField
                type="text"
                label="Option Three"
                placeholder="Option Three"
                value={optionThree}
                name="optionThree"
                handleChange={handleInputChange}
              />
              <FormField
                type="text"
                label="Option Four"
                placeholder="Option Four"
                value={optionFour}
                name="optionFour"
                handleChange={handleInputChange}
              />
              <div className="userUpdateItem">
                <label className="user__label">Right Answer</label>
                <select
                  value={rightAnswer}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      rightAnswer: e.target.value,
                    });
                  }}
                >
                  <option value="0">None</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
              {/* /*{" "}
              <ReactTextArea
                lable="Title"
                Fieldname="title"
                mainvalue={reactTeaxttitle}
                valuename="reactTeaxttitle"
                onChangeFunction={onChangeFunction}
              />{" "}
              */}
              <ReactTextArea
                lable="Solution Description"
                Fieldname="solution_description"
                mainvalue={reactTeaxtdescription}
                valuename="reactTeaxtdescription"
                onChangeFunction={onChangeFunction}
              />
            </>
          )}

          <div>
            <button className="userUpdateButton" type="submit">
              {show.loading ? (
                "Loading......"
              ) : (
                <>{params.id ? "Update Pyq" : "Add Pyq"}</>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
